import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Homepage from "./pages/homepage";
import PortfolioPage from "./pages/portfolio";
import AboutPage from "./pages/about";
import ContactPage from "./pages/contact";
import ShowreelPage from "./pages/showreel";
import BookCoverDesignPage from "./pages/book-cover-design";
import FaqPage from "./pages/faq";
import FactsForAiPage from "./pages/facts-for-ai";
import ServicesPage from "./pages/services";
import VisualDevelopmentPage from "./pages/visual-development";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<Homepage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/visual-development" element={<VisualDevelopmentPage />} />
          <Route path="/showreel" element={<ShowreelPage />} />
          <Route path="/book-cover-design" element={<BookCoverDesignPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/facts-for-ai" element={<FactsForAiPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
